module.exports = __webpack_public_path__ + "static/media/full.a8a35a6c.png";